<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/mould/mold/insert/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions> </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            setDefaultValue();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }}</el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger" @click="yt.remove(scope.row, '/web/basic/mould/mold/insert/delete')">{{ $t('shanchu') }}</el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xiangjianbianma')" required="required">
            <el-input v-model.trim="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xiangjianmingcheng')" required="required">
            <el-input v-model.trim="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpingbianma/mingcheng')">
            <yi_data_select :type="'material2'" :ids.sync="yt.editObj.materialId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shuliang')" required="required">
            <el-input-number v-model="yt.editObj.num" :min="1"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="(yt.editObj.num = parseInt(yt.editObj.num)), yt.req('POST', '/web/basic/mould/mold/insert/create', null, fetchData)" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xiangjianbianma')" required="required">
            <el-input v-model.trim="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xiangjianmingcheng')" required="required">
            <el-input v-model.trim="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpingbianma/mingcheng')">
            <yi_data_select :type="'material2'" :ids.sync="yt.editObj.materialId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shuliang')" required="required">
            <el-input-number v-model="yt.editObj.num" :min="1"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="(yt.editObj.num = parseInt(yt.editObj.num)), yt.req('POST', '/web/basic/mould/mold/insert/update', null, fetchData)" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { min } from 'mathjs';

export default {
  name: 'web_base_mould_mould_equipment_insert',
  components: {},
  data() {
    return {
      columns: [
        {
          label: 'xiangjianbianma',
          prop: 'code',
          // type: 'dictionary',
          // key: 'PARAMETER_TYPE',
          width: 130
        },
        {
          label: 'xiangjianmingcheng',
          prop: 'name',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 130
        },
        {
          label: 'shuliang',
          prop: 'num'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 130,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      // table列表接口请求参数
      this.yt.conditions = {
        mouldId: this.$attrs.mouldEquipment.id,
        orderBy: 'createTime desc'
      };
      this.yt.get(1);
    }, 300);
  },

  mounted() {},

  methods: {
    setDefaultValue() {
      this.yt.editObj.mouldId = this.$attrs.mouldEquipment.id;
    }
  }
};
</script>

<style></style>
